import { styled, TextField } from "@mui/material";

export const StyledTextField = styled(
    TextField,
  )(({theme}) => ({
    input: {
      color: theme.palette.primary.main,
    },
  }));